
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/funnel-series",
      function () {
        return require("private-next-pages/x/api/charts/funnel-series.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/funnel-series"])
      });
    }
  